import { connect } from 'react-redux'
import { slide } from './actions'
import { VolumeSlider } from '../components/slider/index';
import { setCustomSlideValue } from '../mapData/mapDataMap'

const mapStateToPropsRes = (state) => {
	var active = false;
	const deportedParent = state.mapData.data.filter(x => x.id === 'deported_pop')[0];

	if (state.mapData.active &&
		(state.mapData.data.filter(x => x.id === 'deported_pop' && x.active).length > 0
		|| deportedParent.childs.filter(x => x.id === 'deported_14' && x.active).length > 0
		|| deportedParent.childs.filter(x => x.id === 'deported_25' && x.active).length > 0
		|| deportedParent.childs.filter(x => x.id === 'deported_other' && x.active).length > 0)) {
		active = true;
	}

	return {
		enabled: active,
		name: 'Apļu izmērs',
		defaultValue: state.pointSizeSlider.percent,
		value: state.pointSizeSlider.percent,
		color: '#333',
		left: state.map.padding[3] + 12 + 'px',
		logo: true
	}
}

const mapDispatchToPropsRes = (dispatch) => {
	return {
		changeCallback: (value) => {
			setCustomSlideValue(value);
			dispatch(slide(value));
		}
	}
}

const PointSizeSliderContainer = connect(
	mapStateToPropsRes,
	mapDispatchToPropsRes
)(VolumeSlider);

export default PointSizeSliderContainer;



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/pointSizeSlider/container.js